import { combineReducers } from '@reduxjs/toolkit';
import createSubjectOnBoardRemarkReducer from './create-subject-on-board-remark';

const subjectOnBoardRemarkReducer = combineReducers({
  createSubjectOnBoardRemark: createSubjectOnBoardRemarkReducer
});

export default subjectOnBoardRemarkReducer;